import dayjs from 'dayjs';
import { PracticeAnalyticsTypes } from '@frontend/api-analytics';

export const isPatientScheduled = (patient: PracticeAnalyticsTypes.PatientInfo, forceNonProceduralChecks?: boolean) => {
  if (!patient.procedures) {
    if (forceNonProceduralChecks) {
      return (
        !!patient.nextVisit ||
        !!patient.nextAppointmentDate ||
        !!patient.nextAppointmentScheduledDate ||
        !!patient.nextHygieneAppointmentDate
      );
    }

    return true;
  }

  let unscheduledProcedure = false;
  for (let i = 0; i < patient.procedures.length; i++) {
    const date = patient.procedures[i].date;
    if (!date) {
      unscheduledProcedure = true;
      continue;
    }
    if (dayjs().diff(date) < 0) {
      return true;
    }
  }
  return !unscheduledProcedure;
};
